module.exports = __webpack_public_path__ + "static/media/mks_logo.9f5aa73f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mks_logo.png
// module id = 280
// module chunks = 0